import { Link } from "react-router-dom";
import './style.scss';

const Card = ({ children, className = '' }) => {
    const cardClass = [
        'card',
        className
    ].join(' ');

    return (
        <div className={cardClass}>
            {children}
        </div>
    );
}

const CardHeaderItem = ({ children }) => (
    <p className="card-header-title">
        {children}
    </p>
);

const CardHeader = ({ children, className = '' }) => {
    const cardHeaderClass = [
        "card-header",
        className
    ].join(' ');

    return (
        <header className={cardHeaderClass}>
            {children}
        </header>
    );

}
const CardContent = ({ children }) => (
    <div className="card-content">
        <div className="content">
            {children}
        </div>
    </div>
);

const CardFooterLinkItem = ({ path, className, children }) => {
    const cardFooterLinkClass = [
        "card-footer-item",
        className
    ].join(' ');

    return (
        <Link to={path} className={cardFooterLinkClass} >
            {children}
        </Link>
    );
}

const CardFooterItem = ({ children, className = '' }) => {
    const cardFooterClass = [
        "card-footer-item",
        className
    ].join(' ');

    return (
        <span className={cardFooterClass}>
            {children}
        </span>
    );
}

const CardFooter = ({ children, className = '' }) => {
    const cardFooterClass = [
        "card-footer",
        className
    ].join(' ');

    return (
        <footer className={cardFooterClass} >
            {children}
        </footer>
    );
}

export { Card, CardContent, CardHeader, CardHeaderItem, CardFooter, CardFooterItem, CardFooterLinkItem };
